import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {MessageService} from "primeng/api";
import {catchError, throwError} from "rxjs";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const messageService = inject(MessageService);

  return next(req).pipe(
    catchError((error: unknown) => {
      const detail = error instanceof HttpErrorResponse
        ? `${error.status} ${error.statusText}: ${describeError(error)}`
        : error instanceof Error
          ? error.message
          : 'An unexpected error occurred.';

      messageService.add({
        severity: 'error',
        summary: 'Request failed',
        detail,
        life: 8000,
      });

      return throwError(() => error);
    }),
  );
};

const describeError = (error: HttpErrorResponse): string => {
  const body = error.error;
  if (typeof body === 'string' && body.length > 0) return body;
  if (body && typeof body === 'object' && 'message' in body && typeof body.message === 'string') {
    return body.message;
  }
  return error.message;
};
